import React from 'react';
import { observer } from 'mobx-react';
import {
    Grid,
    Box,
} from '@material-ui/core';

import Widget from '../../components/Widget/Widget.jsx';
import {
    Typography,
} from '../../components/Wrappers/Wrappers.jsx';
import useUserPublisherInfo from '../../store/models/user/useUserPublisherInfo';
import EcalWorldProfileSwitch from './EcalWorldProfileSwitch';
import PhotoUpload from './PhotoUpload';
import useCoverPhoto from './useCoverPhoto';
import useEcalWorldAsDev from './useEcalWorldAsDev';
import { useStyles } from './styles';

const ECAL_WORLD_DESCRIPTION_1 = 'ECAL World is our high-intent consumer discovery hub where millions of active users search for and sync official events directly to their personal calendars.';

const ECAL_WORLD_DESCRIPTION_2 = 'By listing on ECAL World, you tap into an active ecosystem built to expand your reach, acquire new subscribers, and drive direct action.';

const ECAL_WORLD_DESCRIPTION_3 = 'Planning an upcoming launch, major event, or priority campaign? Submit a request for spotlight featured placement to maximise your visibility.';

function EcalWorld () {
    const { publisher } = useUserPublisherInfo();
    const classes = useStyles();
    const { devAccess } = useEcalWorldAsDev();

    const {
        coverPhoto,
        handleUpload,
        handleDelete,
        renderErrorDialog,
    } = useCoverPhoto();

    // Temporarily only allow developers to access this.
    if (!devAccess) {
        return null;
    }

    return (
        <React.Fragment>
            <Grid container>
                <Grid item xs={12}>
                    <Widget
                        className={classes.widgetContainer}
                        title="ECAL World"
                        buttonFlag={false}
                        inheritHeight
                        disableWidgetMenu
                    >
                        <Box className={classes.descriptionBox}>
                            <Typography variant='body2'>
                                { ECAL_WORLD_DESCRIPTION_1 }
                            </Typography>

                            <Typography variant='body2'>
                                { ECAL_WORLD_DESCRIPTION_2 }
                            </Typography>

                            <Typography variant='body2'>
                                { ECAL_WORLD_DESCRIPTION_3 }
                            </Typography>
                        </Box>
                    </Widget>
                </Grid>

                <Grid item xs={12} className={classes.centerWrapper}>
                    <Box
                        className={classes.boxStyling}
                    >
                        <Typography
                            variant={'h5'}
                            style={{ marginBottom: 24 }}
                        >
                            ECAL World Marketing
                        </Typography>

                        <EcalWorldProfileSwitch publisher={publisher} />

                        <PhotoUpload
                            title={'Upload a Cover Photo'}
                            description={'This image will appear on your ECAL World profile. Upload a JPG or PNG image, 300px (width) x 250px (height), 6:5 ratio recommended.'}
                            imageSource={coverPhoto}
                            onUpload={handleUpload}
                            onDelete={handleDelete}
                        />
                    </Box>
                </Grid>
            </Grid>

            { renderErrorDialog() }
        </React.Fragment>
    );
}

const ObservedEcalWorld = observer(EcalWorld);
export default ObservedEcalWorld;
